import React from "react";
import Modal from "react-bootstrap/Modal";
import { formatNumber } from "utils/currencyFormat";
import { getDate, currentDate, formatDayMonth } from "utils/formatDate";
import { convertToNumber } from "utils/numberExtension";
import { pushNotification } from "utils/notifications";
import ChiTietChoVaySub from "../ChiTietChoVaySub";
import LanThanhToanView from "../LanThanhToanView";
import DateTimePicker from "components/GenericComponent/DateTimePicker";
import { convertDate } from "utils/formatDate";
import { LaiSuatText, getLaiSuat } from "constants/choVayConst";
import choVayConst from "constants/choVayConst";
import thayDoiLaiSuatApi from "service/thayDoiLaiSuatApi";
import TatToanChoDuyetApi from "../../../service/tatToanChoDuyetApi";
import { currentDateV2 } from "utils/formatDate";
import CauHinhApi from "service/cauHinhApi";

class TraBotGoc extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      choVay: {},
      dataSearch: {
        choVayId: 0,
        pageIndex: 1,
        pageSize: 6,
      },
      objTraBotGoc: {
        choVayId: 0,
        TenKhachHang: "",
        NgayThucHien: "",
        SoTien: 0,
        PhiKhac: 0,
        LaiSuatMoi: 0,
        GhiChu: "",
      },
      HasTatToanChoDuyet: 0,
      dataTraBotGocSearch: {
        choVayId: 0,
        pageIndex: 1,
        pageSize: 10,
      },
      actionDelete: false,
      idDelete: 0,
    };
    this.TenKhachhang = React.createRef();
    this.SoTien = React.createRef();
    this.LaiSuatMoi = React.createRef();
  }
  componentDidMount() {
    let { data, show } = this.props;
    let { choVay, objTraBotGoc } = this.state;
    if (data && show) {
      let { dataSearch, dataTraBotGocSearch } = this.state;
      dataSearch.choVayId = data.ChoVayId;
      dataTraBotGocSearch.choVayId = data.ChoVayId;
      objTraBotGoc.choVayId = data.ChoVayId;
      objTraBotGoc.TenKhachHang = data.CustomerName;
      objTraBotGoc.NgayThucHien = currentDate();

      CauHinhApi.getTimeServer().then((response) => {
        if (response.status === 200) {
          let dateTime = new Date(convertDate(response.data.result));
          objTraBotGoc.NgayThucHien = currentDateV2(dateTime);
        }
      });
      this.setState({
        choVay: data,
        dataSearch,
        objTraBotGoc,
        dataTraBotGocSearch,
      });
      this.loadLanDongLai(dataSearch);
      this.loadLichSuTraBotGoc(dataTraBotGocSearch);
      this.kiemTraHopDongChoVayTatToanChoDuyet();
    }
    if (data === choVay && !show) this.setState({ choVay: {} });
  }

  kiemTraHopDongChoVayTatToanChoDuyet() {
    let { data } = this.props;
    let { HasTatToanChoDuyet } = this.state;
    TatToanChoDuyetApi.kiemTraHopDongChoVayTatToanChoDuyet(data.ChoVayId).then(
      (response) => {
        if (
          response.data != null &&
          response.data != undefined &&
          response.data.TatToanChoDuyet
        ) {
          HasTatToanChoDuyet = response.data.TatToanChoDuyet;
          this.setState({ HasTatToanChoDuyet });
        }
      }
    );
  }
  loadLanDongLai(dataSearch) {
    let { getLanDongLaiChoVay } = this.props;
    getLanDongLaiChoVay(dataSearch);
  }
  loadLichSuTraBotGoc(dataSearch) {
    let { getLichSuTraBotGocChoVay } = this.props;
    getLichSuTraBotGocChoVay(dataSearch);
    let { actionDelete } = this.state;
    setTimeout(() => {
      actionDelete = false;
      this.setState({ actionDelete });
    }, 5000);
  }
  onChangeData = (field) => (event) => {
    let { objTraBotGoc } = this.state;
    objTraBotGoc[field] = event.target.value;
    this.setState({ objTraBotGoc });
  };
  handlePageChange = () => (pageNumber) => {
    let { dataSearch } = this.state;
    dataSearch.pageIndex = pageNumber;
    this.setState({ dataSearch });
    this.loadLanDongLai(dataSearch);
  };
  handlePageChangeTraBotGoc = (pageNumber) => {
    let { dataTraBotGocSearch } = this.state;
    dataTraBotGocSearch.pageIndex = pageNumber;
    this.setState({ dataTraBotGocSearch });
    this.loadLichSuTraBotGoc(dataTraBotGocSearch);
  };
  traBotGoc = () => () => {
    let { dataSearch, objTraBotGoc } = this.state;
    let { postTraBotGocChoVay } = this.props;
    if (!objTraBotGoc.TenKhachHang) {
      pushNotification("Nhập tên người trả.", "warning", "TOP_CENTER", 1000);
      this.TenKhachhang.current.focus();
      return;
    }
    if (!objTraBotGoc.SoTien) {
      pushNotification("Nhập tiền trả gốc", "warning", "TOP_CENTER", 1000);
      this.SoTien.current.focus();
      return;
    }

    postTraBotGocChoVay(
      {
        ...objTraBotGoc,
      },
      dataSearch
    );
    objTraBotGoc.SoTien = 0;
    objTraBotGoc.PhiKhac = 0;
    objTraBotGoc.GhiChu = "";
    this.setState({ objTraBotGoc });
  };
  deleteTraBotGoc = (thuChi) => () => {
    let { deleteTraBotGoc } = this.props;
    let { dataSearch, actionDelete, idDelete } = this.state;
    actionDelete = true;
    this.setState({ actionDelete });
    idDelete = thuChi.ThuChiId;
    this.setState({ idDelete });
    deleteTraBotGoc(
      {
        choVayId: dataSearch.choVayId,
        thuchiId: thuChi.ThuChiId,
      },
      dataSearch
    );
    setTimeout(() => {
      actionDelete = false;
      this.setState({ actionDelete });
    }, 5000);
  };
  renderTraBotGocRow(List) {
    return List.map((item, index) => {
      return (
        <div class="custom-table-row">
          <div class="custom-table-cell username-cell flex-basis-6 disk-mobile">
            <span class="mobile-column-name">STT</span>
            <div class="center-wrapper">
              <p class="text-center">{index + 1}</p>
            </div>
          </div>

          <div class="custom-table-cell flex-basis-15 disk-mobile">
            <span class="mobile-column-name">Tên khách hàng</span>
            <div class="center-wrapper">
              <p class="text-left">{item.Name}</p>
            </div>
          </div>

          <div class="row-show-three">
            <div class="row-mobile">
              <div class="custom-table-cell flex-basis-10">
                <span class="mobile-column-name disk-mobile">Ngày trả bớt</span>
                <div class="center-wrapper">
                  <p class="icon-dropdown-mobile text-center">
                    <i class="mdi mdi-arrow-down-drop-circle collapsible"></i>
                    {getDate(item.Time)}
                  </p>
                </div>
              </div>

              <div class="custom-table-cell flex-basis-15 flex-disk">
                <span class="mobile-column-name  disk-mobile">
                  Tiền trả bớt
                </span>
                <div class="center-wrapper">
                  <p class="text-right">{formatNumber(item.Value)}</p>
                </div>
              </div>
            </div>

            <div class="form-row-detail content12">
              <div class="custom-table-cell flex-basis-15 ">
                <span class="mobile-column-name">Phí khác</span>
                <div class="center-wrapper">
                  <p class="text-right">{formatNumber(item.OtherFee)}</p>
                </div>
              </div>

              <div class="custom-table-cell flex-basis-29  ">
                <span class="mobile-column-name">Ghi chú</span>
                <div class="center-wrapper">
                  <p class="text-left">{item.Note}</p>
                </div>
              </div>
            </div>

            <div
              class="custom-table-cell flex-basis-10 sticky-icon "
              style={{ display: "inline-block", textAlign: "center" }}
            >
              <div class="center-wrapper">
                <div class="inputTableMorman">
                  {item.IsDelete &&
                    this.state.actionDelete == false &&
                    this.state.idDelete != item.ThuChiId &&
                    this.state.HasTatToanChoDuyet !== 1 && (
                      <a
                        href={() => false}
                        onClick={this.deleteTraBotGoc(item)}
                      >
                        <i className="mdi mdi-delete"></i>
                      </a>
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    });
  }
  onChangeDate = (field) => (evt) => {
    let { objTraBotGoc } = this.state;
    objTraBotGoc[field] = formatDayMonth(evt);
    this.setState({ objTraBotGoc });
  };
  onChangeData = (field) => (event) => {
    let { objTraBotGoc } = this.state;
    objTraBotGoc[field] = event.target.value;
    this.setState(objTraBotGoc);
  };
  onChangeNumber = (field) => (evt) => {
    let { objTraBotGoc } = this.state;
    objTraBotGoc[field] = convertToNumber(evt.target.value);
    this.setState(objTraBotGoc);
  };
  render() {
    let props = this.props;
    let {
      data,
      quanlychovay,
      buttonLeft,
      chonngaygiaodich,
      quyenThayDoiLaiSuat,
    } = this.props;
    let {
      List,
      TongCanThanhToan,
      TongPhiKhac,
      TongPhiKho,
      TongThanhToan,
      TongTienGoc,
      TongTienLai,
      totalRow,
      TongPhiKhacHangKy,
      TongTienGocConLai,
    } = quanlychovay.objListDonglai;
    let { ListTraBotGoc } = quanlychovay.LichSuTraBotGoc;
    let { getLanDongLaiChoVayLoading, traBotGocChoVayLoading } = quanlychovay;
    let { dataSearch, objTraBotGoc } = this.state;
    let { TenKhachHang, NgayThucHien, SoTien, PhiKhac, LaiSuatMoi, GhiChu } =
      objTraBotGoc;
    if (NgayThucHien) NgayThucHien = convertDate(NgayThucHien);
    let { Type, StatusPaidHo } = data;
    return (
      <Modal
        {...props}
        size="modal-xl modal-xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="modal-new fade text-left"
      >
        <Modal.Header>
          <h4 className="modal-title color7-bold" id="myModalLabel16">
            <span className="btn-icon-right">
              <img src="/app-assets/images/logo-tra-bot-goc-v2.png" />
            </span>
            <span style={{ marginLeft: "-20px", marginTop: "10px" }}>
              Trả bớt gốc
            </span>
          </h4>
          <button
            type="button"
            className="close-popup-new"
            onClick={props.onHide}
          >
            <i className="mdi mdi-close"></i>
          </button>
        </Modal.Header>
        <Modal.Body className="modal-thanh-toan-new">
          <div
            className={
              "loader loader-default " +
              (getLanDongLaiChoVayLoading || traBotGocChoVayLoading
                ? "is-active"
                : "")
            }
          ></div>
          {this.state.HasTatToanChoDuyet === 1 && (
            <>
              <div className="row">
                <div className="col-md-12">
                  <div className="thongbaotattoan">
                    <i class="mdi mdi-alert" style={{ color: "#d39c00" }}></i>{" "}
                    HỢP ĐỒNG ĐANG CHỜ DUYỆT YÊU CẦU TẤT TOÁN
                  </div>
                </div>
              </div>
            </>
          )}
          <div className="row">
            <div className="col-md-12 col-lg-3  pad-right0">
              <div class="donglai-form">
                <h4>
                  <span style={{ fontWeight: "bold !important;" }}>
                    {"    "}
                    <img src="/app-assets/images/icon-noi-dung-tra goc-v2.png" />
                    &nbsp;&nbsp; Nội dung trả
                  </span>
                </h4>
                <div className="tab-content">
                  <div
                    role="tabpanel"
                    className="tab-pane active"
                    id="tab-noidungtra"
                    aria-labelledby="base-tab1"
                  >
                    <div className="detail-tattoan">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="form-group">
                            <label>Ngày trả gốc</label>
                            <DateTimePicker
                              value={NgayThucHien}
                              onChange={this.onChangeDate("NgayThucHien")}
                              readOnly={!chonngaygiaodich}
                            ></DateTimePicker>
                          </div>
                        </div>

                        <div className="col-md-12">
                          <div className="form-group">
                            <label>Tên khách hàng</label>
                            <input
                              type="text"
                              className="form-control input-sm"
                              value={TenKhachHang}
                              ref={this.TenKhachhang}
                              onChange={this.onChangeData("TenKhachHang")}
                            />
                          </div>
                        </div>

                        <div className="col-md-12">
                          <div className="form-group">
                            <label>Tiền trả gốc</label>
                            <input
                              type="text"
                              className="form-control input-sm"
                              value={formatNumber(SoTien)}
                              data-toggle="popover"
                              data-placement="top"
                              title=""
                              data-content="Năm triệu năm trăm nghìn đồng"
                              data-original-title=""
                              ref={this.SoTien}
                              onChange={this.onChangeNumber("SoTien")}
                            />
                          </div>
                        </div>
                        {quyenThayDoiLaiSuat && (
                          <>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Lãi suất cũ</label>
                                <input
                                  type="text"
                                  className="form-control input-sm"
                                  value={LaiSuatText(data, data.KieuLaiSuat)}
                                  ref={this.KieuLaiSuat}
                                  disabled={true}
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Kiểu lãi suất</label>
                                <input
                                  type="text"
                                  className="form-control input-sm"
                                  value={
                                    choVayConst.KieuLaiSuatText[
                                      data.KieuLaiSuat
                                    ]
                                  }
                                  ref={this.KieuLaiSuat}
                                  disabled={true}
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Lãi suất mới</label>
                                <input
                                  type="text"
                                  className="form-control input-sm"
                                  value={formatNumber(LaiSuatMoi)}
                                  data-toggle="popover"
                                  data-placement="top"
                                  title=""
                                  data-content="Năm triệu năm trăm nghìn đồng"
                                  data-original-title=""
                                  ref={this.LaiSuatMoi}
                                  onChange={this.onChangeNumber("LaiSuatMoi")}
                                />
                              </div>
                            </div>
                          </>
                        )}

                        <div className="col-md-12">
                          <div className="form-group">
                            <label>Phí khác</label>
                            <input
                              type="text"
                              className="form-control input-sm"
                              value={formatNumber(PhiKhac)}
                              data-toggle="popover"
                              data-placement="top"
                              title=""
                              data-content="Năm triệu năm trăm nghìn đồng"
                              data-original-title=""
                              onChange={this.onChangeNumber("PhiKhac")}
                            />
                          </div>
                        </div>

                        <div className="col-md-12">
                          <div className="form-group">
                            <label>Ghi chú</label>
                            <textarea
                              rows="3"
                              className="form-control input-sm textarea-fixed-height"
                              placeholder="Ghi chú"
                              value={GhiChu}
                              onChange={this.onChangeData("GhiChu")}
                            ></textarea>
                          </div>
                        </div>

                        <div className="col-md-12">
                          <div className="text-right">
                            {this.state.HasTatToanChoDuyet !== 1 && (
                              <button
                                type="button"
                                className="btn btn-new-main btn-checknew"
                                onClick={this.traBotGoc()}
                              >
                                <span className="btn-icon-left">
                                  <i className="mdi mdi-check-underline-circle"></i>
                                </span>{" "}
                                Xác nhận
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-12 col-lg-9 col-md-9-customers">
              <div className="tattoan-formright">
                <ul className="nav nav-tabs bg-tab tab-vaythem">
                  <li className="nav-item active">
                    <a
                      className="nav-link active"
                      id="base-tab12"
                      data-toggle="tab"
                      aria-controls="tab12"
                      href="#tbg-thongtinhd"
                      aria-expanded="true"
                    >
                      <h4>Thông tin hợp đồng</h4>
                    </a>
                  </li>

                  <li className="nav-item active">
                    <a
                      className="nav-link"
                      id="base-tab13"
                      data-toggle="tab"
                      aria-controls="tab13"
                      href="#detailtbg"
                      aria-expanded="true"
                    >
                      <h4>Chi tiết đóng lãi</h4>
                    </a>
                  </li>
                </ul>
                <div className="tab-content">
                  <div
                    role="tabpanel"
                    className="tab-pane active"
                    id="tbg-thongtinhd"
                    aria-labelledby="base-tab1"
                  >
                    <div>
                      <div className="row">
                        <div className="col-md-12 col-sm-12">
                          <ChiTietChoVaySub
                            data={data}
                            TongTienGoc={
                              TongTienGocConLai
                                ? TongTienGocConLai
                                : TongTienGoc
                            }
                          ></ChiTietChoVaySub>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    role="tabpanel"
                    className="tab-pane"
                    id="detailtbg"
                    aria-labelledby="base-tab1"
                  >
                    <LanThanhToanView
                      List={List}
                      TongCanThanhToan={TongCanThanhToan}
                      TongPhiKhac={TongPhiKhac}
                      TongPhiKho={TongPhiKho}
                      TongThanhToan={TongThanhToan}
                      TongTienGoc={TongTienGoc}
                      TongTienLai={TongTienLai}
                      totalRow={totalRow}
                      TongPhiKhacHangKy={TongPhiKhacHangKy}
                      handlePageChange={this.handlePageChange()}
                      pageIndex={dataSearch.pageIndex}
                      pageSize={dataSearch.pageSize}
                      Type={Type}
                      StatusPaidHo={StatusPaidHo}
                    ></LanThanhToanView>
                  </div>
                </div>
              </div>
            </div>
            <div className="list-history" style={{ marginTop: "10px" }}>
              <h4 className="modal-title color7-bold" id="myModalLabel16">
                <span>Lịch sử trả bớt gốc</span>
              </h4>
              <div class="Left808x200 Table-main-new table-mobile-new">
                <div class="table-responsive table-responsive-new table-new1  table-rounded">
                  <div class="custom-table-wrapper custom-border-mm">
                    <div class="table-headers">
                      <div class="custom-table-header flex-basis-6">
                        <p class="text-center">
                          <span class="color-do-bold">
                            [ {ListTraBotGoc.length} ]
                          </span>
                        </p>
                      </div>

                      <div class="custom-table-header flex-basis-15 ">
                        <p class="text-left">Tên khách hàng</p>
                      </div>
                      <div class="custom-table-header flex-basis-10 ">
                        <p class="text-center">Ngày trả bớt gốc</p>
                      </div>

                      <div class="custom-table-header flex-basis-15">
                        <p class="text-right">Tiền trả bớt gốc</p>
                      </div>
                      <div class="custom-table-header flex-basis-15">
                        <p class="text-right">Phí khác</p>
                      </div>
                      <div class="custom-table-header flex-basis-29 ">
                        <p class="text-left">Ghi chú</p>
                      </div>
                      <div class="custom-table-header flex-basis-10">
                        <p class="tab-header text-center">Thao tác</p>
                      </div>
                    </div>

                    <div class="custom-table-body">
                      <div class="custom-table-row">
                        <div class="custom-table-cell username-cell-mobile flex-basis-6 disk-desktop show-mobile">
                          <span class="mobile-column-name">Ngày trả</span>
                          <div class="center-wrapper">
                            <p class="text-center">Tiền trả bớt</p>
                          </div>
                        </div>
                      </div>
                      {this.renderTraBotGocRow(ListTraBotGoc)}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div class="from-button-modal">
            <div class="row">
              <div class="col-md-9">{buttonLeft}</div>
              <div class="col-md-3 text-right">
                <button
                  type="button"
                  className="btn btn-new-main btn-checknew"
                  onClick={props.onHide}
                >
                  &nbsp;
                  <i class="mdi mdi-close"></i>
                  &nbsp; Đóng&nbsp;
                </button>
              </div>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}
export default TraBotGoc;
